import { render } from "./person-access-detail.vue?vue&type=template&id=75db053e"
import script from "./person-access-detail.vue?vue&type=script&lang=js"
export * from "./person-access-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__